import produce from "immer";

import { Action, actionCreators } from "../actions";

const initialStore = {
    isPrivate: false,
    value: "",
    nameTakenError: null as string | null,
    otherError: null as string | null,
    newForumModalVisible: false,
};
type Store = Readonly<typeof initialStore>;

export const update = produce((draft, action: Action): Store | void => {
    if (
        action.type === actionCreators.onLogout.type ||
        action.type === actionCreators.CreateForumSuccess.type
    ) {
        return initialStore; // reset
    } else if (action.type === actionCreators.ToggleIsNewForumPrivate.type) {
        draft.isPrivate = !draft.isPrivate;
    } else if (action.type === actionCreators.NewForumName.type) {
        const { value } = action.payload;
        draft.value = value;
        draft.nameTakenError = null;
        draft.otherError = null;
    } else if (action.type === actionCreators.ToggleNewForumModalVisible.type) {
        draft.newForumModalVisible = !draft.newForumModalVisible;
    } else if (action.type === actionCreators.CreateForumError.type) {
        const { payload, operation } = action.payload;
        if (payload.code === "forum_name_is_in_use") {
            const { name } = operation;
            draft.nameTakenError = name;
        } else {
            console.error("Failed to create forum", action);
            draft.otherError = "Something wrong";
        }
    }
}, initialStore);

export type OuterStore = { createForumModal: Store };

export function getIsNewForumPrivate(store: OuterStore) {
    return store.createForumModal.isPrivate;
}

export function getValue(store: OuterStore) {
    return store.createForumModal.value;
}

export function getNewForumModalVisible(store: OuterStore) {
    return store.createForumModal.newForumModalVisible;
}

export function getNameTakenError(store: OuterStore) {
    return store.createForumModal.nameTakenError;
}

export function getOtherError(store: OuterStore) {
    return store.createForumModal.otherError;
}
